import { invalidateQuery, noddiAsync, URLKeys } from 'noddi-async';
import { useParams } from 'react-router-dom';

// The facility slug in the URL is the credential for every write on the page.
export const useSaveExternalChecks = () => {
  const { publicSlug } = useParams() as { publicSlug: string };
  const mutation = noddiAsync.usePatch({
    type: URLKeys.patchFacilityTransferExternalCheckBulkPublic,
    queryConfig: {
      // The status badges on the cards are the confirmation; a toast per answer is noise.
      meta: { suppressSuccessToast: true },
      onSuccess: () => invalidateQuery({ urlKey: URLKeys.getFacilityTransferDayPublic })
    }
  });
  return { ...mutation, publicSlug };
};
